import request from "@/utils/request";

// 查询测试树表列表
export function newsTree(query) {
    return request({
        url: '/system/newsClassify/tree',
        method: 'get',
        params: query
    })
}

//新闻列表
export function noticeList(query) {
    return request({
        url: '/system/notice/list',
        method: 'get',
        params: query
    })
}

// 查询新闻详细
export function getnewsNotice(id) {
    return request({
        url: '/system/notice/' + id,
        method: 'get'
    })
}

// 查询数据产品详细
export function getPd(query) {
    return request({
        url: '/collect/detail/',
        method: 'get',
        params: query
    })
}

// 查询数据产品详细
export function getSts(data) {
    return request({
        url: '/collect/sts',
        method: 'post',
        data: data
    })
}

// 查询新闻热点
export function gethotNews(qurey) {
    return request({
        url: '/system/notice/hot',
        method: 'get',
        params: qurey
    })
}

//人才招聘
export function getrcList() {
    return request({
        url: 'bsRecruit/list',
        method: 'get'
    })
}

//数据源
export function getdictType(query) {
    return request({
        url: '/collect/dict',
        method: 'get',
        params: query
    })
}